export default "__VITE_ASSET__B80snl3W__"